// The waveform is one atomic component even though its preparation has three asynchronous/
// fallible boundaries. Only the current generation may advance, and "ready" exists only after
// bytes, decode/peaks and the first draw have all completed in that order.
export class WaveformLoadState {
  constructor({ onLoading = () => {}, onReady = () => {}, onFailure = () => {} } = {}) {
    this.onLoading = onLoading
    this.onReady = onReady
    this.onFailure = onFailure
    this.generation = 0
    this.stage = "idle"
  }

  start() {
    this.generation += 1
    this.stage = "loading"
    this.onLoading()
    return this.generation
  }

  fetched(generation) {
    return this.#advance(generation, "loading", "fetched")
  }

  decoded(generation) {
    return this.#advance(generation, "fetched", "decoded")
  }

  drawn(generation) {
    if (!this.#advance(generation, "decoded", "ready")) return false
    this.onReady()
    return true
  }

  fail(generation) {
    if (!this.#current(generation) || ["ready", "failed"].includes(this.stage)) return false
    this.stage = "failed"
    this.onFailure()
    return true
  }

  cancel() {
    this.generation += 1
    this.stage = "idle"
  }

  #advance(generation, from, to) {
    if (!this.#current(generation) || this.stage !== from) return false
    this.stage = to
    return true
  }

  #current(generation) {
    return generation === this.generation
  }
}
